import styled from "styled-components"

export const StyledSpacing = styled.div`
    margin-top: 24px;
`
